import { Box, Button, DialogTitle } from "@mui/material";
import Colors from "@src/constants/Colors";
import styled from "styled-components";

export const DialogWrapper = styled(Box)`
  padding: 24px;
`;

export const StyledDialogTitle = styled(DialogTitle)`
  &.MuiDialogTitle-root {
    font-weight: bold;
  }
`;

export const DialogButtonWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`;

export const DialogButtonConfirm = styled(Button)`
  &.MuiButtonBase-root {
    width: 150px;
    height: 40px;
    padding: 14px 16px;
    gap: 8px;
    border-radius: 8px;
    box-shadow: none;
    background-color: ${Colors.secondary};
    color: #fff;
    line-height: 20px;
    font-family: "Ringside Regular-Book";
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    text-transform: capitalize;

    &:hover {
      background-color: ${Colors.secondary};
      box-shadow: none;
    }
  }
`;

export const DialogButtonCancel = styled(Button)`
  &.MuiButtonBase-root {
    width: 150px;
    height: 40px;
    padding: 14px 16px;
    gap: 8px;
    border-radius: 8px;
    box-shadow: none;
    border: 1px solid ${Colors.secondary};
    color: ${Colors.secondary};
    line-height: 20px;
    font-family: "Ringside Regular-Book";
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    text-transform: capitalize;

    &:hover {
      box-shadow: none;
    }
  }
`;
